import * as React from 'react';
import { connect } from 'react-redux';
import SignForm from "./SignInForm";
import { checkIsWeb } from '../appRedux/actions/MobAppFn';
 
const SignIn = () => (
    checkIsWeb().exist &&
    <div className="signin-panel-form-wrapper">
                            <SignForm />
                        </div>
   
);


//export default connect()(SignIn);
export default SignIn;